(function ($, Drupal) {
  'use strict';

  Drupal.behaviors.pageSearchV1 = {
    attach: function (context, settings) {
      /* global generic */
      var qs = generic.env.parsedQuery(),
        undef,
        $headerSearch = $('.header-search', context),
        $searchIcon = $headerSearch.find('.header-search__icon'),
        $search = $('input[name="search"]', $('.page-search__form')),
        $filterTrigger = $('.search-results').find('.search-filter__trigger'),
        $resultCountLabel = $('.search-results').find('.search-filter__trigger-text span'),
        $filterContainer = $('.search-filter__container', context);

      // Populate the counter and show filter trigger
      $(context).on('endeca.search.results.loaded', function (event, data) {
        var numResults = data.meta.totalAggrRecords,
          hasRefinements = data.meta.dimensions.refinements;

        // @TODO this is hidden per bug i235192 until we see if we can make counts more accurate
        //      if ($search != undef) {
        //        $resultCountLabel.text(numResults);
        //      }

        if (hasRefinements != undef && hasRefinements.length) {
          $filterTrigger.show();
        }
        // 2021 style refresh - add a class to the page form
        if (Drupal.settings.globals_variables && Drupal.settings.globals_variables.cr21) {
          $search.addClass('cr21-refresh');
        }

        // scroll to previous scroll position, if exists
        if (sessionStorage.searchScrollPos) {
          $(window).scrollTo(sessionStorage.searchScrollPos);
          sessionStorage.removeItem('searchScrollPos');
        }

        // save current scroll position to session
        var $viewAll = $('.search-results').find('a.view-all');

        $viewAll.once().click(function (e) {
          var scrollPos = window.pageYOffset;

          sessionStorage.setItem('searchScrollPos', scrollPos);
        });
      });

      // Open/close filter button
      $filterTrigger.on('click', function (e) {
        $(this).toggleClass('search-filter--open');
        $filterContainer.toggle();
        $(this).attr('aria-expanded', $(this).attr('aria-expanded') === 'true' ? 'false' : 'true');
        $(this).focus();
      });
      $filterTrigger.on('keydown', function (e) {
        if (site.getKeycode(e) === 13) {
          $(this).trigger('click');
        }
      });
    }
  };
  $('.js-search_results_title').focus();
})(jQuery, Drupal);
